import React from 'react';
import { CheckBoxField } from '../../../../../components/formFields/CheckBox';
import { DatePickerField } from '../../../../../components/formFields/DatePicker';
import { RadioButtonField } from '../../../../../components/formFields/RadioButton';
import { SelectField } from '../../../../../components/formFields/Select';
import { TextField } from '../../../../../components/formFields/TextField';
import { useSectionData } from '../hooks/dataContext';

const GetFormElement = (elementName: string, elementSchema: any) => {
  const { label, options, values, required: isRequired, type } = elementSchema;
  const props = {
    name: elementName,
    label,
    options,
    values,
    required: isRequired,
    type,
  };
  const requiredObj = {
    name: elementName,
    required: isRequired,
    type,
  };

  const { requiredFields } = useSectionData();
  if (isRequired) requiredFields.push(requiredObj);

  switch (type) {
    case 'text':
    case 'email':
    case 'password':
      return <TextField {...props} />;
    case 'checkbox':
      return <CheckBoxField {...props} />;
    case 'radio':
      return <RadioButtonField {...props} />;
    case 'select':
      return <SelectField {...props} />;
    case 'date':
      return <DatePickerField {...props} />;
    default:
      return null;
  }
};

export default GetFormElement;
